module.exports = __webpack_public_path__ + "static/media/caricatura2.1f189778.png";